import $ from 'jquery';
import {Tags}from '../../shared/Tags';

$(() => {
    if ($('.js-tags-shuffle').length){
        const tags = new Tags('.js-tags-shuffle');
    }
})



// WEBPACK FOOTER //
// ./app/scripts/pages/solutions/index.js